import { Button, Paper, useMediaQuery } from '@mui/material'
import Grid from '@mui/material/Grid2'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { format as dateFnsFormat } from 'date-fns/format'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSocketData } from '../../../api/websockets/useSocketData'
import CancelIcon from '../../../assets/icons/Cancel.svg?react'
import RepeatIcon from '../../../assets/icons/Repeat.svg?react'
import { AssistantDisconnectDialog } from '../../../dialogs/AssistantDisconnectDialog'
import { BalanceDialog } from '../../../dialogs/BalanceDialog'
import { PaymentFailedDialog } from '../../../dialogs/PaymentFailedDialog/PaymentFailedDialog'
import { PaymentSuccessfulDialog } from '../../../dialogs/PaymentSuccessfulDialog/PaymentSuccessfuDialog'
import { useProfileStore } from '../../../store/storeProfile'
import { useWrapperStore } from '../../../store/storeWrapper'
import { UserWalletDTO } from '../../../swagger/dto'
import { theme } from '../../../theme'
import { PaymentStatus } from '../../../types/billing'
import { getDateFnsLocale } from '../../../utils/dateLocale'
import { Billing } from '../../InternalPage/FinancesPage/components/billing/Billing'
import { PackageListCard } from '../../InternalPage/FinancesPage/components/PackageListCard'
import { RecurringPayment } from '../../InternalPage/FinancesPage/components/RecurringPayment'

export const FinancesPage = () => {
    const { t, i18n } = useTranslation()
    const { assistantSubscriptions, changeAssistantSubscription, fetchAssistantSubscriptions } =
        useWrapperStore((state) => state)

    const [openAssistantDisconnectDialog, setOpenAssistantDisconnectDialog] =
        useState<boolean>(false)
    const [assistantSelected, setAssistantSelected] = useState({})

    const handleCloseAssistantDisconnectDialog = () => {
        setOpenAssistantDisconnectDialog(false)
    }

    const handleSubmitAssistantDisconnectDialog = () => {}

    const handleOpenAssistantDisconnectDialog = async (item) => {
        if (item.auto_renew) {
            setAssistantSelected(item)
            setOpenAssistantDisconnectDialog(true)
        } else {
            await changeAssistantSubscription(item.id)
            fetchAssistantSubscriptions()
        }
    }

    const isMobile = useMediaQuery(theme.breakpoints.down('md'))
    const [searchParams, setSearchParams] = useSearchParams()
    const [openPaymentDialog, setOpenPaymentDialog] = useState<boolean>(false)
    const [openPaymentSuccessfulDialog, setOpenPaymentSuccessfulDialog] = useState<boolean>(false)
    const [openPaymentFailedDialog, setOpenPaymentFailedDialog] = useState<boolean>(false)

    const {
        fetchTariffList,
        fetchRecurringPayment,
        userTariff,
        recurringPayment,
        fetchStorageTariffs,
        fetchStorageTariffUser,
    } = useProfileStore((state) => state)

    useEffect(() => {
        fetchTariffList()
        fetchRecurringPayment()
        fetchStorageTariffs()
        fetchStorageTariffUser()
    }, [])

    useEffect(() => {
        const paymentStatus = searchParams.get('paymentStatus')

        if (
            recurringPayment &&
            recurringPayment.is_active !== true &&
            paymentStatus === PaymentStatus.SUCCESS
        ) {
            setOpenPaymentSuccessfulDialog(true)
        }

        if (paymentStatus === PaymentStatus.ERROR) {
            setOpenPaymentFailedDialog(true)
        }

        if (searchParams.get('isOpenTariffDialog') === 'true') {
            setOpenPaymentDialog(true)
        }
    }, [searchParams, recurringPayment])

    const handleClosePaymentDialog = () => {
        setOpenPaymentDialog(false)
    }
    const handleClickOpenPaymentDialog = () => {
        setOpenPaymentDialog(true)
    }

    const handleClosePaymentSuccessfulDialog = () => {
        setOpenPaymentSuccessfulDialog(false)
    }
    const handleClosePaymentFailedDialog = () => {
        setOpenPaymentFailedDialog(false)
    }

    const { data } = useSocketData<UserWalletDTO>('wallet/ws')

    const { setWallet } = useProfileStore((state) => state)

    useEffect(() => {
        if (data) {
            setWallet(data)
        }
    }, [data])

    return (
        <>
            <PackageListCard isWebView={true} />
            <Grid container spacing={1}>
                {userTariff?.tariff?.title !== 'Бесплатный' && (
                    <Grid size={{ xs: isMobile ? 12 : 6 }}>
                        <RecurringPayment
                            isWebView={true}
                            open={() => setOpenPaymentSuccessfulDialog(true)}
                        />
                    </Grid>
                )}

                {/*<Grid*/}
                {/*    size={{ xs: userTariff?.tariff?.title === 'Бесплатный' || isMobile ? 12 : 6 }}>*/}
                {/*    <ReferralBlock isWebView={true} />*/}
                {/*</Grid>*/}
                {/*<Grid size={12}>*/}
                {/*    <Storage />*/}
                {/*</Grid>*/}
            </Grid>

            <Paper
                sx={{
                    marginBottom: '0',
                    backgroundColor: '#fff',
                    height: '100%',
                    padding: '12px',
                }}>
                <Typography
                    sx={{
                        marginBottom: '12px',
                        color: '#000',
                    }}
                    variant="h4">
                    {t('finances.assistantSubscriptions')}
                </Typography>

                {assistantSubscriptions?.length > 0 &&
                    assistantSubscriptions.map((item, index) => {
                        return (
                            <Stack
                                mb={2}
                                p={2}
                                sx={{
                                    borderRadius: '12px',
                                    background: ' #F5F5F5',
                                }}>
                                <Typography variant="h5" my={1}>
                                    {item.assistant_name}
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#5A5C5E' }}>
                                    {t('finances.status')}:{' '}
                                    <span style={{ color: '#1B1C1D' }}>
                                        {' '}
                                        {item.is_active ? t('finances.active') : t('finances.paused')}
                                    </span>
                                </Typography>
                                <Typography variant="body2" sx={{ color: '#5A5C5E' }}>
                                    {t('finances.activeUntil')}:{' '}
                                    <span style={{ color: '#1B1C1D' }}>
                                        {' '}
                                        {dateFnsFormat(item?.end_at, 'd MMMM yyyy', {
                                            locale: getDateFnsLocale(i18n.language),
                                        })}
                                    </span>
                                </Typography>
                                <Button
                                    onClick={() => handleOpenAssistantDisconnectDialog(item)}
                                    variant="text"
                                    startIcon={item.auto_renew ? <CancelIcon /> : <RepeatIcon />}
                                    sx={{
                                        justifyContent: 'left',
                                        gap: '4px',
                                        px: '0px',
                                        '&>.MuiButton-icon': {
                                            mr: 0,
                                        },
                                    }}>
                                    {item.auto_renew ? t('finances.cancelSubscription') : t('finances.renewSubscription')}
                                </Button>
                            </Stack>
                        )
                    })}
                {assistantSubscriptions?.length === 0 && (
                    <Typography variant="body2" sx={{ color: '#5A5C5E' }}>
                        {t('finances.noActiveSubscriptions')}
                    </Typography>
                )}
            </Paper>

            <AssistantDisconnectDialog
                assistant={assistantSelected}
                open={openAssistantDisconnectDialog}
                handleSubmit={handleSubmitAssistantDisconnectDialog}
                handleClose={handleCloseAssistantDisconnectDialog}
            />

            <Paper>
                <Grid sx={{ height: 'auto', overflowY: 'auto' }}>
                    <Billing isWebView={true} />
                </Grid>
            </Paper>

            <PaymentSuccessfulDialog
                type={
                    searchParams.get('paymentStatus') === PaymentStatus.SUCCESS
                        ? 'success'
                        : recurringPayment?.is_active
                          ? 'change'
                          : 'connect'
                }
                open={openPaymentSuccessfulDialog}
                handleClose={handleClosePaymentSuccessfulDialog}
            />
            <PaymentFailedDialog
                open={openPaymentFailedDialog}
                handleClose={handleClosePaymentFailedDialog}
                handleOpenPaymentDialog={handleClickOpenPaymentDialog}
            />
            <BalanceDialog open={openPaymentDialog} handleClose={handleClosePaymentDialog} />
        </>
    )
}
